import "flag-icons/css/flag-icons.min.css";

interface FlagIconProps {
    iso: string;
    title?: string;
    className?: string;
}

/**
 * Renders a real SVG country flag via the `flag-icons` package.
 *
 * Emoji flags (Unicode regional-indicator pairs) do not render on Windows
 * browsers and several others, so the Foreign Missions UI uses these instead.
 * The flag is drawn as a `cover` background so it fills a circular badge.
 */
export default function FlagIcon({ iso, title, className = "" }: FlagIconProps): JSX.Element {
    return (
        <span
            className={`fi fi-${iso} ${className}`}
            style={{
                display: "block",
                width: "100%",
                height: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            role="img"
            aria-label={title}
            title={title}
        />
    );
}
